
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.782 23.087C38.393 16.474 31.683 12 24 12S9.605 16.477 6.218 23.088c-.29.574-.29 1.25 0 1.825C9.607 31.526 16.317 36 24 36s14.395-4.477 17.782-11.088c.29-.574.29-1.25 0-1.825zM24 33a9 9 0 110-18 9 9 0 010 18zm0-15a5.958 5.958 0 00-1.582.237 2.99 2.99 0 01-4.181 4.181A5.986 5.986 0 1024 18z","fill":"#535353"}})])
          )
        }
      }
    